import { Grid } from "@mui/material";

// Each input owns its Grid cell so the field bodies stay a flat list.

const GridItem = ({ md = 6, lg, children }) => (
  <Grid
    item
    xs={12}
    md={md}
    lg={lg}
  >
    {children}
  </Grid>
);

export default GridItem;
